import Link from "next/link";
const styles = new Proxy({"Tag":"Tag-9951d"}, { get: (m, k) => (typeof k === "string" ? (m[k] ?? k) : m[k]) });
import { Tag as TagType } from "../../types";

const Tag = ({ tag }: TagProps) => (
  <Link
    href={tag.slug}
    className={`btn rounded-pill m-1 p-0 px-3 ${styles.Tag}`}
  >
    {tag.name}
  </Link>
);

interface TagProps {
  tag: TagType;
}

export default Tag;
